import BillingService from '@/services/BillingService';
import Loading from '@/components/widget/Loading';
import DiscountCode from '@/components/billing/DiscountCode';
import BillingList from '@/components/billing/List';
import PayBalanceConfirm from '@/components/billing/PayBalanceConfirm';
export default {
  name: 'PayBalance',
  components: {
    Loading,
    DiscountCode,
    BillingList,
    PayBalanceConfirm
  },
  props: {
    subscription: Object,
    states: Array,
    countries: Array
  },
  data() {
    return {
      openModal: false,
      openConfirm: false,
      loading: false,
      status: null,
      transactions: null,
      discount: null,
      billing: {},
      subscription_id: null,
      subscriptiontype_id: null,
      payment: null
    };
  },
  methods: {
    init() {
      this.loading = true;
      BillingService.paymentInit().then(response => {
        this.billing = {};
        this.discount = null;
        this.cvc = null;
        this.cvcValid = false;
        this.status = response.data.status;
        this.transactions = response.data.transactions;
        if (!this.subscription && this.transactions.length > 0) {
          this.subscription_id = this.transactions[0].subscription_id;
          this.subscriptiontype_id = this.transactions[0].subscription.subscriptiontype_id;
        } else {
          this.subscription_id = this.subscription.id;
          this.subscriptiontype_id = this.subscription.subscriptiontype_id;
        }
      }).catch(error => {
        this.$aim.error(error.response);
        this.close();
      }).finally(() => {
        this.loading = false;
      });
    },
    payBalance() {
      if (!this.loading && this.isValid) {
        this.prepData();
        this.openConfirm = true;
      }
    },
    prepData() {
      this.payment = {
        status: this.status,
        subscription: this.subscription,
        transactions: this.transactions,
        billing: this.billing,
        discount: this.discount,
        amount: this.amountDue,
        localamount: this.amountDueFormatted
      };
    },
    close() {
      this.$nextTick(() => {
        this.$bvModal.hide('pay-balance-modal');
      });
    },
    setBilling(info) {
      this.billing = info;
    },
    clearBilling() {
      this.billing = {};
    }
  },
  computed: {
    amountDue() {
      return this.status ? this.status.balance : 0;
    },
    amountDueFormatted() {
      return this.status ? this.status.localbalance.localcurrencyformatted : 0;
    },
    isValid() {
      return this.billing && this.billing.id;
    }
  },
  watch: {
    openModal(n, o) {
      if (n && !o) {
        this.init();
      }
    }
  }
};